import { QueryClient } from '@tanstack/react-query';

export default new QueryClient({
  defaultOptions: {
    queries: {
      /**
       * By default, React will re-fetch data when the window regains focus.
       * This is a bit aggressive, especially in development where you might be
       * opening/closing the DevTools/refocusing the tab (which happens a lot).
       *
       * Later we should consider turning this on, especially for production,
       * as it can be nice for users to see the freshest data when they return.
       */
      refetchOnWindowFocus: false,

      /**
       * By default, React Query will retry failed requests 3 times w/exponential backoff.
       * We're going to disable this for now, but we should consider turning this on later.
       */
      retry: false,

      /**
       * This refers to how long React Query will consider the data fresh.
       * If the data is older than this time, React Query will consider it stale and will trigger a new fetch.
       * Setting this to 0 means that the data will always be considered stale and will always trigger a new fetch.
       * This is a good default ("the server state is always correct"), but can be adjusted on a per-query basis
       * for data which is isn't expected to change often.
       */
      staleTime: 0,

      /**
       * This option defines how long the query’s result will be considered fresh before it is evicted from the cache.
       * After the cache time period has passed, any subsequent requests for this data will trigger a new fetch,
       * and the cache will be updated with the new data.
       */
      cacheTime: 1000 * 60 * 1, // 1 minute
    },
    mutations: {
      /**
       * By default, React Query will retry failed mutations 3 times w/exponential backoff.
       * We're going to disable this for now, but we should consider turning this on later.
       */
      retry: false,
    },
  },
});
